/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

export type RatingUmbBlockPartialElementModelContentType =
	(typeof RatingUmbBlockPartialElementModelContentType)[keyof typeof RatingUmbBlockPartialElementModelContentType];

export const RatingUmbBlockPartialElementModelContentType = {
	ratingUmbBlockPartial: "ratingUmbBlockPartial",
} as const;
